export default __webpack_public_path__ + "assets/img/company-story-img01.png";